export enum TaskPriority {
    UserBlocking = "user-blocking",
    UserVisible = "user-visible",
    Background = "background",
}

// Откладывание тяжелых задач, которые тормозят отзывчивость UI
// подробнее https://wicg.github.io/scheduling-apis/
// Покороче и на русском https://web.dev/articles/optimize-long-tasks?hl=ru
export function schedulerWrapper(cl: () => void, opts?: { priority: TaskPriority }): void {
    scheduler.postTask(cl, opts);
}
